import React, { useState, useEffect } from 'react'
import Alert from '@material-ui/lab/Alert';
import BillingForm from './BillingForm';
import BillingAddressPreview from './BillingAddressPreview';
import axios from 'axios'

const BillingAddress = ({ customerId, connectedStripeId }) => {
  const API_URL = 'https://1d6q9mtu49.execute-api.us-west-2.amazonaws.com';
  
  const [isLoading, setIsLoading] = useState(false);
  const [displayBillingForm, setDisplayBillingForm] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [billingInfo, setBillingInfo] = useState({
    city: "",
    line1: "",
    line2: "",
    state: "",
    country: "",
    postal_code: ""
  });
    
  // fetch and load the customer's billing info 
  useEffect(() => {

    (async () => {
      setIsLoading(true);

      const { data } = await axios.post(`${API_URL}/retrieve-customer`, { 
        customerId, 
        connectedStripeId
      });

      setBillingInfo(data.address)
      setIsLoading(false);
    })()

  },[customerId]);

  useEffect(() => {
    // clear success message
    setTimeout(() => setSuccessMessage(''), 5000)
  },[successMessage])

  return (
    <>

      {successMessage && 
        <Alert variant="filled" severity="success">
          {successMessage}
        </Alert>
      }

      {!isLoading && !displayBillingForm  &&
        <BillingAddressPreview 
          billingInfo={billingInfo} 
          setDisplayBillingForm={setDisplayBillingForm}/>
      }

      {displayBillingForm && 
        <BillingForm 
          billingInfo={billingInfo}
          customerId={customerId}
          connectedStripeId={connectedStripeId}
          setBillingInfo={setBillingInfo}
          setSuccessMessage={setSuccessMessage}
          setDisplayBillingForm={setDisplayBillingForm}/>
      }
    
    </>
  )
}

export default BillingAddress;